import { render } from "./DriverForm.vue?vue&type=template&id=1f8596d3&scoped=true"
import script from "./DriverForm.vue?vue&type=script&lang=js"
export * from "./DriverForm.vue?vue&type=script&lang=js"

import "./DriverForm.vue?vue&type=style&index=0&id=1f8596d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8596d3"]])

export default __exports__